import React from "react";
import "./LearningSession.css";
import LeMerridian from "../../../../assets/img/unsplash_xEaAoizNFV8.png";
import Session from "../../../../assets/Icon/email.png";
import { Link } from "react-router-dom";

const RequestLearnList = () => {
  return (
    <>
      <div className="col-md-12 ">
        <div className="d-flex pt-3">
          <div className="faTrophy">
            <i className="fas fa-trophy"></i>
          </div>
          <h4 className="mx-3 text-light p-2">
            Requested Learning Session ( Schedule )
          </h4>
        </div>

        <div className="row">
          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddussond Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-3">
            <Link
              to="/superstar/learning-session/request/event"
              className="LinkEventSchedule"
            >
              <div className="card card-bg my-3 card-dashbord">
                <div className="card-body mb-2 text-black">
                  <center>
                    <img
                      src={Session}
                      className="img-fluid MessageIcon"
                      alt=""
                    />
                    <div className="centeredImgC fw-bold">23</div>
                  </center>
                  <div className="d-flex justify-content-between">
                    <img src={LeMerridian} alt="Snow" className="ImgSMeet" />
                    <div className="top-left-SAch">
                      <span>
                        <h5 className="mt-2 text-warning">Raddusson Blue</h5>
                        <p className="text-white">
                          Lorem Ipsum is simply dummy text of the printing and
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestLearnList;
